module.exports = __webpack_public_path__ + "img/linkedin.daf419e1.svg";